import { render, staticRenderFns } from "./HeaderView.vue?vue&type=template&id=4a871e74&"
import script from "./HeaderView.vue?vue&type=script&lang=js&"
export * from "./HeaderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports